@if (isMovingBasket$ | async) {
<atx-loader-overlay
  i18n-loaderText="@@MovingBasket"
  loaderText="Moving your basket..."
  data-e2e="cbasket-moving-overlay"
></atx-loader-overlay>
}

<atx-modal-header
  class="accounts-header pb-0"
  [showCloseBtn]="isInBasket"
  (dismiss)="close()"
>
  <div
    class="px-1 py-2 font-weight-bold"
    i18n="accountSelector|Header text for select action@@accountsActionSelect"
  >
    Select account and ship-to address(es)
  </div>
  <epc-search-accounts-input></epc-search-accounts-input>
</atx-modal-header>

<atx-modal-body class="p-0 d-flex flex-column">
  <epc-accounts-form
    [loading]="isLoading$ | async"
    [isSingleSelection]="isSingleSelection$ | async"
    [isMoveBasketEnabled]="(isMoveBasketEnabled$ | async) && isInBasket"
    [currentBasketAccountIds]="initialSelectedAccountIds$ | async"
    [searchValue]="accountSearchValue$ | async"
    [shouldHighlightAddress]="shouldHighlightAddress$ | async"
    [accounts]="sortedAccounts$ | async"
    [isAccountAddressReverted]="isAccountAddressReverted$ | async"
    [noSearchResult]="noSearchResult$ | async"
    [shouldScrollToTheTop]="searchCleared$ | async"
    [selectedAccountIds]="selectedAccountIds$ | async"
    [selectedAddressIds]="selectedAddressesIds$ | async"
    (setNextPage)="setPage()"
    (toggleAccountSelection)="handleAccountToggle($event)"
    (toggleAddressSelection)="handleAddressToggle($event)"
  >
  </epc-accounts-form>
</atx-modal-body>

<atx-modal-footer class="modal-footer">
  @if (isInBasket) { @if ({ isChangeActiveAccountAlertShown:
  isChangeActiveAccountAlertShown$ | async, appliedActiveAccount:
  appliedActiveAccount$ | async, isMoveBasketFlow: isMoveBasketFlow$ | async,
  addedCount: addedAddressesCount$ | async, removedCount: removedAddressesCount$
  | async, isSelectedAccountHasNoAvailableItemsError:
  isSelectedAccountHasNoAvailableItemsError$ | async }; as ctx) { @if (
  ctx.isChangeActiveAccountAlertShown &&
  !ctx.isSelectedAccountHasNoAvailableItemsError ) {
  <div class="w-100">
    <atx-alert [severity]="severity.Information" class="mb-0">
      <span
        i18n="
          Accounts|Changing active account
          message@@changeActiveAccountAlertMessage"
      >
        You active account will be changed to
        {{ ctx.appliedActiveAccount.name }} -
        {{ ctx.appliedActiveAccount.externalId }}
      </span>
    </atx-alert>
  </div>
  } @if (ctx.isMoveBasketFlow) {
  <div class="w-100">
    @if ( ctx.isSelectedAccountHasNoAvailableItemsError) {
    <atx-alert [severity]="severity.Warning" class="mb-0">
      <span
        i18n="
          Accounts|No basket items in account
          alert@@noBasketItemInAccountErrorAlert"
        >No basket items are available for selected account
      </span>
    </atx-alert>
    } @else {
    <atx-alert [severity]="severity.Information" class="mb-0">
      <span i18n="Accounts|Move basket alert message@@moveBasketAlertMessage">
        Your products will be removed from current account and added to
        {{ ctx.appliedActiveAccount.name }} -
        {{ ctx.appliedActiveAccount.externalId }}
      </span>
    </atx-alert>
    }
  </div>
  } @else { @if (ctx.addedCount || ctx.removedCount) {
  <div class="w-100">
    <atx-alert [severity]="severity.Information">
      @if (ctx.addedCount && ctx.removedCount) {
      <span
        i18n="
          Accounts|Add and remove shops alert
          message@@addAndRemoveShopsAlertMessage"
      >
        Your products will be removed from {{ ctx.removedCount }} and added to
        {{ ctx.addedCount }} shop{ctx.addedCount + ctx.removedCount, plural,
        =1{} other {s}}</span
      >
      } @if (ctx.addedCount && !ctx.removedCount) {
      <span i18n="Accounts|Add shops alert message@@addShopsAlertMessage">
        Your products will be added to
        {{ ctx.addedCount }} shop{ctx.addedCount + ctx.removedCount, plural,
        =1{} other {s}}</span
      >
      } @if (ctx.removedCount && !ctx.addedCount) {
      <span i18n="Accounts|Remove shops alert message@@RemoveShopsAlertMessage">
        Your products will be removed from
        {{ ctx.removedCount }} shop{(ctx.addedCount + ctx.removedCount), plural,
        =1{} other {s}}</span
      >
      }
    </atx-alert>
  </div>
  } }
  <button
    type="button"
    data-e2e="cancel-btn"
    (click)="close()"
    i18n="Accounts|Cancel text@@cancel"
    class="btn btn-light mr-3"
  >
    Cancel
  </button>
  @if (ctx.isMoveBasketFlow) {
  <button
    type="button"
    data-e2e="confirm-btn"
    [disabled]="ctx.isSelectedAccountHasNoAvailableItemsError"
    (click)="moveBasket()"
    i18n="Accounts|Move basket to other account button@@moveBasketBtn"
    class="btn btn-primary"
  >
    Move Basket
  </button>
  } @else {
  <button
    type="button"
    data-e2e="confirm-btn"
    [disabled]="isConfirmButtonDisabled$ | async"
    (click)="handleConfirmAndProceed()"
    i18n="Accounts|Confirm and proceed text@@addAndRemoveShops"
    class="btn btn-primary"
  >
    Add ({{ ctx.addedCount }}) / Remove ({{ ctx.removedCount }}) Shops
  </button>
  } } } @else {
  <button
    type="button"
    data-e2e="logout-btn"
    (click)="handleLogout()"
    i18n="Accounts|Logout text@@logoutBtnTextInAccounts"
    class="btn btn-alpha-primary mr-auto"
  >
    Logout
  </button>
  <ng-container *ngrxLet="selectedShopsCount$ as count">
    <button
      type="button"
      data-e2e="confirm-btn"
      [disabled]="isConfirmButtonDisabled$ | async"
      (click)="handleConfirmAndProceed()"
      i18n="Accounts|Confirm and proceed text@@confirmAndProceedAccounts"
      class="btn btn-primary"
    >
      Confirm and proceed {count, plural, =0{} =1{for 1 shop} other {for
      {{ count }} shops}}
    </button>
  </ng-container>
  }
</atx-modal-footer>
